import { FC } from 'react';

import { Link } from '@inertiajs/react';
import { LayoutGrid } from 'lucide-react';

import { cn } from '../../utils';

interface SellerProductTypeNavigationItem {
    href: string;
    label: string;
    active?: boolean;
    testId?: string;
}

interface Props {
    items: SellerProductTypeNavigationItem[];
    singleRow?: boolean;
    dataTestId?: string;
}

export const SellerProductTypeNavigation: FC<Props> = ({
    items,
    singleRow = false,
    dataTestId,
}) => {
    if (items.length <= 1) {
        return null;
    }

    return (
        <div
            className={cn(
                'flex items-center gap-2.5',
                singleRow ? 'w-max flex-nowrap' : 'flex-wrap',
            )}
        >
            <div className="inline-flex shrink-0 items-center rounded-full bg-primary/10 px-3 py-2 text-xs font-semibold tracking-[0.16em] text-primary uppercase">
                <LayoutGrid className="mr-1.5 h-3.5 w-3.5" />
                Тип товару
            </div>

            <nav
                className={cn(
                    'flex gap-2',
                    singleRow ? 'flex-nowrap' : 'flex-wrap',
                )}
                aria-label="Тип товару продавця"
                data-testid={dataTestId}
            >
                {items.map((item) => (
                    <Link
                        key={item.href}
                        href={item.href}
                        aria-current={item.active ? 'page' : undefined}
                        data-testid={item.testId}
                        className={cn(
                            'inline-flex min-h-9 items-center justify-center rounded-full border px-3 text-xs font-medium whitespace-nowrap transition-colors',
                            item.active
                                ? 'border-primary bg-primary/10 text-primary'
                                : 'border-border bg-background text-muted-foreground hover:border-primary/30 hover:text-foreground',
                        )}
                    >
                        {item.label}
                    </Link>
                ))}
            </nav>
        </div>
    );
};
